import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
const facebook = (props) => (
  <SvgIcon viewBox="0 0 14.4 14.4" {...props}>
    <path d="M13.6,0H.795A.8.8,0,0,0,0,.795V13.606a.8.8,0,0,0,.795.794h6.9V8.824H5.815V6.65H7.692v-1.6a2.619,2.619,0,0,1,2.8-2.873,15.394,15.394,0,0,1,1.677.086V4.2H11.014c-.9,0-1.077.429-1.077,1.058V6.651h2.152l-.28,2.173H9.937V14.4h3.67a.8.8,0,0,0,.794-.8V.795A.8.8,0,0,0,13.6,0Z" />
  </SvgIcon>
);
export default facebook;



// WEBPACK FOOTER //
// ./src/common/icons/Facebook/index.tsx